(function () {
  document.documentElement.classList.add('has-js');

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      button.setAttribute('aria-label', isOpen ? 'فتح القائمة' : 'إغلاق القائمة');
      nav?.classList.toggle('is-open', !isOpen);
    });
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const badge = gallery.querySelector('[data-gallery-badge]');
    const fitMainImage = () => {
      if (!main || !main.naturalWidth || !main.naturalHeight) return;
      main.classList.toggle('is-tall', main.naturalHeight / main.naturalWidth > 1.15);
    };
    if (main) {
      main.addEventListener('load', fitMainImage);
      fitMainImage();
    }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
        if (!main || !image) return;
        const nextSource = button.dataset.large || image.currentSrc || image.src;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = nextSource;
        main.alt = image.alt;
        main.classList.toggle('is-tall', button.dataset.portrait === 'true');
        if (badge) badge.hidden = button.dataset.noBadge === 'true';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
        button.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('[data-size-guide-open]').forEach((button) => {
    button.addEventListener('click', () => document.getElementById(button.dataset.sizeGuideOpen)?.showModal());
  });
  document.querySelectorAll('[data-dialog-close]').forEach((button) => {
    button.addEventListener('click', () => button.closest('dialog')?.close());
  });
  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  document.querySelectorAll('.product-info__form').forEach((form) => {
    const selects = Array.from(form.querySelectorAll('[data-option-index]'));
    const variantScript = form.querySelector('[data-variants]');
    const variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    const idInput = form.querySelector('[name="id"]');
    const productInfo = form.closest('.product-info');
    const priceNode = productInfo?.querySelector('[data-variant-price]');
    const compareNode = productInfo?.querySelector('[data-variant-compare]');
    const submit = form.querySelector('[data-product-submit]');
    const submitText = submit?.querySelector('[data-submit-text]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const bundleChoices = Array.from(form.querySelectorAll('[data-bundle-choice]'));
    const currencyCode = productInfo?.dataset.currencyCode || window.Shopify?.currency?.active || 'USD';
    const formatMoney = (minorUnits) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'ar', { style: 'currency', currency: currencyCode }).format(minorUnits / 100);
      } catch (error) {
        return (minorUnits / 100).toFixed(2) + ' ' + currencyCode;
      }
    };
    const refreshBundles = (unitPrice) => {
      bundleChoices.forEach((choice) => {
        const card = choice.closest('.bundle-option');
        const count = Number(choice.dataset.quantity || 1);
        const percent = Number(choice.dataset.percent || 0);
        const subtotal = unitPrice * count;
        const total = Math.round(subtotal * (1 - percent / 100));
        const totalNode = card?.querySelector('[data-bundle-total]');
        const subtotalNode = card?.querySelector('[data-bundle-subtotal]');
        const savingNode = card?.querySelector('[data-bundle-saving]');
        if (totalNode) totalNode.textContent = formatMoney(total);
        if (subtotalNode) {
          subtotalNode.textContent = formatMoney(subtotal);
          subtotalNode.hidden = percent <= 0;
        }
        if (savingNode) savingNode.hidden = percent <= 0;
      });
    };
    bundleChoices.forEach((choice) => {
      choice.addEventListener('change', () => {
        if (quantityInput) quantityInput.value = choice.dataset.quantity || '1';
        bundleChoices.forEach((item) => item.closest('.bundle-option')?.classList.toggle('is-selected', item.checked));
      });
    });
    const unavailableText = submit?.dataset.unavailableText || 'غير متوفر حالياً';
    const availableText = submit?.dataset.availableText || 'أضيفي إلى السلة';
    const syncVariant = () => {
      if (!selects.length || !variants.length) return;
      const selected = selects.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceNode) priceNode.textContent = variant.price;
      if (variant.priceRaw != null) refreshBundles(Number(variant.priceRaw));
      if (compareNode) {
        compareNode.textContent = variant.compare || '';
        compareNode.hidden = !variant.compare;
      }
      if (submit) {
        submit.disabled = !variant.available;
        if (submitText) submitText.textContent = variant.available ? availableText : unavailableText;
      }
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', variantUrl.toString());
    };
    const initialVariant = variants.find((item) => String(item.id) === String(idInput?.value));
    if (initialVariant?.priceRaw != null) refreshBundles(Number(initialVariant.priceRaw));
    selects.forEach((select) => select.addEventListener('change', syncVariant));
  });
})();
